import { render, staticRenderFns } from "./NativePay.vue?vue&type=template&id=218b9120&"
import script from "./NativePay.vue?vue&type=script&lang=js&"
export * from "./NativePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports